import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useResearchAdmin() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['is-research-admin', user?.id],
    enabled: Boolean(user?.id),
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_research_admin');
      if (error) {
        console.warn('is_research_admin failed:', error.message);
        return false;
      }
      return data === true;
    },
    staleTime: 5 * 60_000,
  });
}
